import { useQuery } from '@tanstack/react-query';

import { Result } from '@/entities';
import { CurrencyFormat, currencyFormats } from '@/entities/shared/lookups/CurrencyFormat';
import { listCurrencies } from '@/infrastructure/network/data/lookups/currency';

export const useCurrencyQuery = (currencyId?: string) => {
	return useQuery<Result<CurrencyFormat>>({
		queryKey: ['CURRENCIES', currencyId],
		queryFn: async () => {
			const result = await listCurrencies();
			const currency = result.data.find((currency) => currency.id === currencyId);

			if (result.statusCode === 200) {
				return { data: currencyFormats[currency?.abbreviation || 'USD'], statusCode: result.statusCode };
			} else {
				return { statusCode: result.statusCode, correlationId: result.correlationId, error: result.error };
			}
		},
		enabled: Boolean(currencyId)
	});
};

export const useCurrenciesQuery = (isEnabled: boolean = false) => {
	return useQuery({
		queryKey: ['ALL_CURRENCIES'],
		queryFn: () => listCurrencies(),
		enabled: isEnabled
	});
};
